export default __webpack_public_path__ + "ui/assets/img/info-invert-32.svg";